<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <OrderDocumentationForm
            ref="orderDocumentationForm"
            @closeDialog="closeDialog"
          />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import OrderDocumentationForm from '@/modules/book/views/task/components/OrderDocumentationForm.vue';

export default {
  name: 'OrderDocumentationDialog',
  components: {OrderDocumentationForm},
  props: {
    hideButton: Boolean
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.orderDocumentationForm.clearForm();
      this.$emit('closeDialog');
    },
    openCreationDialog(createData) {
      this.dialog = true;
      this.$refs.orderDocumentationForm.setCreateData(createData);
    },
    viewDialog(orderDocumentation) {
      this.dialog = true;
      this.$refs.orderDocumentationForm.setViewData(orderDocumentation);
    }
  }
}
</script>